export default "__VITE_ASSET__C9gH5Ld0__"